<template>
    <b-card
        no-body
        class="card-payment"
    >
        <b-card-header>
            <b-card-title>Filtro</b-card-title>
        </b-card-header>
        <b-card-body>
            <b-form>
                <b-row>
                    <b-col lg="3" md="6" sm="6">
                        <b-form-group
                            label="Código instalación"
                            label-for="code"
                            class="mb-2"
                        >
                            <b-form-input
                                id="code"
                                v-model="search.gei_code"
                                type="text"
                                autocomplete="off"
                                @keyup="searchChildrenInstallation()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col lg="1" md="6" sm="6">
                      <b-form-group
                          label="Instalación Activa"
                          label-for="active"
                          class="mb-2"
                      >
                        <select v-model="search.active_installation" class="custom-select" @change="searchChildrenInstallation()">
                          <option value=""/>
                          <option v-for="status in boolean"
                                  :key="status.value"
                                  :value="status.value"> {{ status.name }}
                          </option>
                        </select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="6" sm="6">
                      <b-form-group
                          label="Cliente"
                          label-for="client"
                          class="mb-2"
                      >
                        <b-form-input
                            id="code"
                            v-model="search.master_installation.client"
                            type="text"
                            autocomplete="off"
                            @keyup="searchChildrenInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="3" md="6" sm="6">
                      <b-form-group
                          label="Responsable"
                          label-for="responsible"
                          class="mb-2"
                      >
                        <v-select
                            v-model="search.master_installation.responsible"
                            class="pt-0" label="name" name="name"
                            :reduce="(option) => option.name"
                            :options="responsiblesList"
                            @input="searchChildrenInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                      <b-form-group
                          label="Tipo de Instalación"
                          label-for="typology"
                          class="mb-2"
                      >
                        <v-select
                            v-model="search.typology"
                            class="pt-0" label="name" name="name"
                            :reduce="(option) => option.name"
                            :options="typologiesList"
                            @input="searchChildrenInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                  <b-col lg="3" md="6" sm="6">
                    <b-form-group label="Proveedor" label-for="provider" class="mb-2">
                      <v-select
                          v-model="search.provider"
                          class="pt-0"
                          label="provider"
                          name="provider"
                          :options="providersList"
                          :reduce="(option) => option.id"
                      multiple
                      @input="searchChildrenInstallation()"
                      />

                    </b-form-group>
                  </b-col>

                  <b-col lg="2" md="6" sm="6">
                      <b-form-group label="País" label-for="country">
                        <v-select
                            v-model="search.master_installation.country"
                            class="pt-0" label="country" name="country"
                            :reduce="(option) => option.country"
                            :options="countriesList"
                            @input="searchChildrenInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                      <b-form-group
                          label="Comunidad autónoma"
                          label-for="autonomous_community"
                          class="mb-2"
                      >
                        <v-select
                            v-model="search.autonomous_community"
                            class="pt-0" label="autonomous_community" name="autonomous_community"
                            :options="autonomousCommunityList"
                            :reduce="(option) => option.autonomous_community"
                            multiple
                            @input="searchChildrenInstallation()"
                        />

                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                      <b-form-group label="Provincia" label-for="province">
                        <v-select
                            v-model="search.master_installation.province"
                            class="pt-0" label="province" name="province"
                            :reduce="(option) => option.province"
                            :options="provincesList"
                            @input="searchChildrenInstallation()">
                            <span slot="no-options">
                                Seleccione un país
                            </span>
                        </v-select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="1" md="6" sm="6">
                      <b-form-group
                          label="Código Postal"
                          label-for="postal_code"
                      >
                        <b-form-input
                            id="postal_code"
                            v-model="search.master_installation.postal_code"
                            type="text"
                            autocomplete="off"
                            @keyup="searchChildrenInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                      <b-form-group
                          label="Empresa"
                          label-for="company_id"
                          class="mb-2"
                      >
                        <v-select
                            v-model="search.master_installation.companies"
                            class="pt-0" label="name" name="name"
                            :reduce="(option) => option.id"
                            :options="companiesList"
                            multiple
                            @input="searchChildrenInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                      <b-form-group
                          label="Expediente Sistema"
                          label-for="proceeding_code"
                          class="mb-2"
                      >
                        <b-form-input
                            id="proceeding_code"
                            v-model="search.master_installation.proceeding_code"
                            type="text"
                            autocomplete="off"
                            @keyup="searchChildrenInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                      <b-form-group
                          label="Expediente PRL"
                          label-for="expedient_prl"
                          class="mb-2"
                      >
                        <b-form-input
                            id="expedient_prl"
                            v-model="search.expedient_prl"
                            type="text"
                            autocomplete="off"
                            @keyup="searchChildrenInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="6" sm="6">
                      <b-form-group
                          label="Número Pedido en Vigor"
                          label-for="order_number"
                          class="mb-2"
                      >
                        <b-form-input
                            id="expedient_prl"
                            v-model="search.documentOrder.order_number"
                            type="text"
                            autocomplete="off"
                            @keyup="searchChildrenInstallation()"
                        />
                      </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-card-body>
    </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardTitle, BCardBody, BRow, BCol, BFormGroup, BFormInput, BForm } from 'bootstrap-vue'
import {createHelpers} from "vuex-map-fields"
import {boolean} from "@/constants/constants"
import vSelect from "vue-select"
import flatPickr from "vue-flatpickr-component"

import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'

const {mapFields} = createHelpers({
    getterType: 'childrenInstallation/getField',
    mutationType: 'childrenInstallation/updateField',
})

export default {
    name: "ChildrenInstallationsSearchView",
    components: {
        vSelect,
        BCard,
        BCardHeader,
        BCardTitle,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormInput,
    },
    props: {
        // eslint-disable-next-line vue/require-default-prop
        clickSearch: {
            type: Function,
        }
    },
    data() {
        return {
            clients: [],
            states: [],
            companiesList: [],
            responsiblesList: [],
            countriesList: [],
            provincesList: [],
            typologiesList: [],
            autonomousCommunityList: [],
            providersList: [],
            opsvaTerritories: [],
            countryId: null,
            SpanishLocale,
            boolean
        }
    },
    computed: {
        ...mapFields({
            search: 'search',
        }),
    },
    watch: {
      "search.master_installation.country": function (country, oldCountryId) {
        this.$emit('update', { country_id: country })
        if (country) {
          const foundCountry = this.countriesList.find(c => c.country === country)
          this.getAllProvincesCountries(foundCountry.country_id)
        }
      },
    },
    mounted() {
        this.getCompanies()
        this.getResponsibles()
        this.getAllCountries()
        this.getTypologies()
        this.getAllProviders()
        this.getAllOPSVATerritories()
        this.getAllDistinctAutonomousCommunity()
    },
    methods: {
        searchChildrenInstallation: function (){
            this.clickSearch()
        },
        getAllProviders() {
          this.$store.dispatch('providers/getAllProviders')
              .then(response => {
                this.providersList = response
              })
              .catch(error => {
                console.log(error)
              })
        },
        getCompanies() {
          this.showLoading = true

          const userCompanies = this.$store.state.AppActiveUser.companies

          if (!userCompanies || userCompanies.length === 0) {
            // Si no hay compañías en AppActiveUser, se obtiene la lista completa
            this.$store.dispatch('companies/getAllCompanies')
                .then(response => {
                  this.companiesList = response
                })
                .catch(error => {
                  console.error("Error obteniendo compañías:", error)
                })
                .finally(() => {
                  this.showLoading = false
                })
          } else {
            // Si ya hay compañias en AppActiveUser, se usan esas
            this.companiesList = userCompanies.map(company => ({
              id: company.id,
              name: company.name
            }))
            this.showLoading = false
          }
        },
        getResponsibles() {
          this.showLoading = true

          const userResponsibles = this.$store.state.AppActiveUser.responsibles

          if (!userResponsibles || userResponsibles.length === 0) {
            // Si no hay responsables en AppActiveUser, se obtiene la lista completa
            this.$store.dispatch('responsibles/getAllResponsibles')
                .then(response => {
                  this.responsiblesList = response
                })
                .catch(error => {
                  console.error("Error obteniendo responsables:", error)
                })
                .finally(() => {
                  this.showLoading = false
                })
          } else {
            // Si ya hay responsables en AppActiveUser, se usan esas
            this.responsiblesList = userResponsibles.map(responsible => ({
              id: responsible.id,
              name: responsible.name
            }))
            this.showLoading = false
          }
        },
        getAllCountries() {
          this.showLoading = true

          this.$store.dispatch('provincesCountries/getAllCountries')
              .then(response => {
                this.countriesList = response
                this.showLoading = false
              })
              .catch(error => {
                this.showLoading = false
              })
        },
        getAllDistinctAutonomousCommunity() {
          this.showLoading = true

          this.$store.dispatch('provincesCountries/getAllDistinctAutonomousCommunity')
              .then(response => {
                this.autonomousCommunityList = response
                this.showLoading = false
              })
              .catch(error => {
                this.showLoading = false
              })
        },
        getAllProvincesCountries(countryId) {
          this.showLoading = true
          this.$store.dispatch('provincesCountries/getAllProvincesByCountry',{
            countryId: countryId,
          })
              .then(response => {
                this.provincesList = response
                this.showLoading = false
              })
              .catch(error => {
                this.showLoading = false
              })
        },

        getTypologies() {
          this.showLoading = true

          const userTypologies = this.$store.state.AppActiveUser.typologies

          if (!userTypologies || userTypologies.length === 0) {
            // Si no hay tipologias en AppActiveUser, se obtiene la lista completa
            this.$store.dispatch('typologies/listTypologies')
                .then(response => {
                  this.typologiesList = response
                })
                .catch(error => {
                  console.error("Error obteniendo tipologias:", error)
                })
                .finally(() => {
                  this.showLoading = false
                })
          } else {
            // Si ya hay tipologias en AppActiveUser, se usan esas
            this.typologiesList = userTypologies.map(typology => ({
              id: typology.id,
              name: typology.name
            }))
            this.showLoading = false
          }
        },

        getAllOPSVATerritories() {
          this.showLoading = true

          this.$store.dispatch('opsvaTerritories/getAllOPSVATerritories')
              .then(response => {
                this.opsvaTerritories = response
                this.showLoading = false
              })
              .catch(error => {
                this.showLoading = false
              })
        },
    }
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>